/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {},
  rules: [],
  tokens: {
    buttonBackgroundColor: null,
    buttonBorderColor: null,
    buttonBorderRadius: null,
    buttonBorderWidth: null,
    buttonHeight: null,
    buttonMinWidth: null,
    buttonTextColor: null,
    buttonWidth: null,
    notificationBackgroundColor: null,
    notificationBorderColor: null,
    notificationBorderRadius: null,
    notificationDismissButtonGap: null,
    notificationDismissIcon: null,
    notificationDismissIconColor: null,
    notificationIcon: null,
    notificationIconColor: null,
    notificationIconGap: null,
    notificationIconSize: null,
    notificationTextColor: '#000000'
  }
}
export default theme
